<template>
  <div
    class="experience-wrapper--body"
    @scroll="updateScrolledToBottom($event)"
  >
    <LadAvailabilityBanner v-if="withBanner" />

    <LazyLoading
      :key="`availability`"
      :loaded="lazy.availability"
      @loaded="(e) => (lazy.availability = e)"
    >
      <template v-for="(item, i) in items">
        <LadAvailabilityItem
          v-if="getItemsByCode(item.code).length === 0"
          :key="`availability-item-modal-${i}`"
          :item="item"
          :experience="experience"
          :platform="platform"
          @open="toogleOpenItem"
          @reserve="handleReserve"
        >
          <template slot="availability-left">
            <slot name="custom-ava-left" />
          </template>
        </LadAvailabilityItem>
        <div
          v-if="platform.name === 'Tourradar'"
          :key="`availability-items-${platform.name}-${i}`"
          class="availability-childs"
        >
          <LadAvailabilityItem
            v-for="(itemByCode, j) in getItemsByCode(item.code)"
            :key="`availability-item-by-code-modal-${j}`"
            :item="itemByCode"
            :experience="experience"
            @open="toogleOpenItem"
            @reserve="handleReserve"
          >
            <template slot="availability-left">
              <slot name="custom-ava-left" />
            </template>
          </LadAvailabilityItem>
        </div>
      </template>
    </LazyLoading>
  </div>
</template>

<script>
export default {
  name: 'LadAvailabilityContent',
  components: {
    LadAvailabilityItem: () =>
      import(/* webpackChunkName: "lad-ava-item" */ './components/item'),
    LadAvailabilityBanner: () =>
      import(
        /* webpackChunkName: "lad-ava-banner" */ '@/components/frontends/Availability/components/banner'
      ),
  },
  props: {
    experience: { type: Object, required: true },
    items: { default: () => [], type: Array, required: true },
    itemsByCode: { default: () => ({}), type: Object },
    platform: { type: Object, required: true },
    withBanner: { type: Boolean, default: false },
  },
  data() {
    return {
      isScrolledToBottom: false, // muestra/oculta efecto degradado de listado de fechas disponibles
      open: null,
      lazy: {
        availability: false,
      },
    }
  },
  watch: {
    isScrolledToBottom(newValue, oldValue) {
      this.$emit('scrolled', newValue)
    },
    items(newValue) {
      this.open = null
    },
  },
  mounted() {
    this.enableScrolledToBottom()
  },
  methods: {
    /** controla visualizacion de efecto inferior de listado de fechas disponibles */
    updateScrolledToBottom(e) {
      // https://stackoverflow.com/a/21067431
      const target = e.target
      this.isScrolledToBottom =
        target.scrollHeight - target.clientHeight <= target.scrollTop + 70
    },
    /** habilita el efecto inferior de listado si hay mas de 5 elementos listados */
    enableScrolledToBottom() {
      this.isScrolledToBottom = this.items.length < 6
    },
    toogleOpenItem(item) {
      let tmp = this.items.find((t) => t.datetime.start === item.datetime.start)
      tmp.open = !item.open

      this.items
        .filter((t) => t.datetime.start !== item.datetime.start)
        .map((t) => (t.open = false))

      tmp = this.items.find((t) => t.open)
      this.open = tmp ? tmp.datetime.start : null
    },
    handleReserve(item) {
      this.$emit('reserve', item)
    },
    getItemsByCode(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.itemsByCode.hasOwnProperty(code)) return this.itemsByCode[code]
      return []
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--body {
  max-height: 500px;
  overflow: auto;
  position: relative;
  background-color: white;

  .lad-container-media-text {
    padding: 0 0 20px;
    border-bottom: 1px solid #ebeef2;
  }

  .lad-container-media-text--left {
    padding-right: 15px;

    .availability-banner--title {
      font-size: 1.6em;
      line-height: 1;
    }

    .el-button {
      min-width: 184px;
    }
  }

  .lad-container-media-text--right {
    .sprite-icons {
      height: 130px;
    }
  }

  .availability-childs {
    background-color: aliceblue;
  }

  @media screen and (max-width: 900px) {
    .lad-container-media-text--left {
      flex-basis: 100%;
    }

    .lad-container-media-text--right {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .lad-container-media-text--left {
      .availability-banner--title {
        line-height: 1.6;
      }
    }
  }
}
</style>
